export default "__VITE_ASSET__6764e61b__"